import { render, staticRenderFns } from "./KusVatDateSelector.vue?vue&type=template&id=08feb46f"
import script from "./KusVatDateSelector.vue?vue&type=script&lang=js"
export * from "./KusVatDateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports